<template>
  <div class="text-N700 mb-4">
    <v-input hide-details class="text-N100 mb-1" v-if="!textVar && title">
      {{ title }}
    </v-input>

    <div class="d-flex align-center">
      <v-text-field
        v-model="modelValue"
        :variant="readonly ? 'plain' : 'outlined'"
        :readonly="readonly"
        :placeholder="placeholder"
        hide-details="auto"
        density="compact"
        :class="readonly ? 'ps-4' : ''"
        v-if="typeInput === 'text'"
        :type="type"
        :prefix="prefix"
        :min="prefix ? 0 : min"
        :max="prefix ? 100 : ''"
        :autofocus="focus"
        :disabled="disabled"
        :required="required"
        :rules="propRules"
      >
        <template v-if="!$slots['append-inner'] && spinButtons" #append-inner>
          <SpinButtons v-model="modelValue" :min="min" :max="max" />
        </template>
        <template v-for="(_, name) in $slots" v-slot:[name]="props">
          <slot :name="name" v-bind="props"> </slot>
        </template>
      </v-text-field>

      <v-select
        v-model="modelValue"
        :variant="textVar ? 'plain' : 'outlined'"
        hide-details="auto"
        density="compact"
        v-else-if="typeInput === 'select'"
        :class="selectClass"
        :items="items"
        @click="click"
        :item-value="selectValue"
        :item-title="selectTitle"
        :multiple="multiple"
        @update:modelValue="$emit('changed')"
        :chips="multiple"
        :disabled="disabled"
        :readonly="readonly"
        :required="required"
        :clearable="clearable"
        :loading="loading"
        :rules="propRules"
      >
        <template v-slot:append-inner>
          <v-icon size="x-small" :class="textVar ? 'mt-3' : ''" class="text-N700"> mdi-chevron-down </v-icon>
        </template>
      </v-select>

      <v-btn color="error" height="40" width="40" class="ms-2" v-if="deletable" @click="$emit('delete')">
        <img :src="require('@/assets/trash.svg')" alt="trash" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import SpinButtons from '@/components/SpinButtons.vue'

export default {
  name: 'CustomInput',
  components: { SpinButtons },
  props: {
    title: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    deletable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    typeInput: {
      type: String,
      default: 'text',
    },
    items: Array,
    number: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: '',
    },
    prefix: String,
    textVar: Boolean,
    time: Boolean,
    focus: Boolean,
    value: [Number, String],
    selectTitle: String,
    selectValue: {
      type: String,
      default: 'id',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: Boolean,
    loading: [Boolean, String],
    rules: Array,
    spinButtons: Boolean,
    placeholder: String,
  },
  data: () => ({ propRules: [] }),
  model: {
    prop: 'value',
    event: 'update:value',
  },
  mounted() {
    this.propRules = this.rules ?? [(v) => !!v || !this.required || '']
    if (!this.modelValue && this.items?.[0]) {
      this.modelValue = this.items[0][this.selectValue]
    }
  },
  methods: {
    click() {
      let intervalCounter = 0
      const interval = setInterval(() => {
        const list = document.querySelector('.v-list')
        if (list) {
          list.addEventListener('scroll', () => {
            if (list.scrollTop >= list.scrollHeight - list.clientHeight - 50) {
              this.$emit('scrolledBottom')
            }
          })
          clearInterval(interval)
        } else if (++intervalCounter >= 4) {
          clearInterval(interval)
        } // try 4 times
      }, 500)
    },
  },
  computed: {
    selectClass() {
      if (!this.textVar) return ''
      if (this.input === 'Not Assigned') return 'd-flex justify-center align-center text-error'
      return 'd-flex justify-center align-center'
    },
    type() {
      if (this.number) return 'number'
      else if (this.time) return 'time'
      else return 'text'
    },
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
      },
    },
  },
}
</script>

<style>
.mdi-menu-down {
  display: none;
}
</style>
